<script>
    import * as Actions from '../store/action-types';

    const minRequired = 1;

    export default {
        mixins: [],

        computed: {
            count() {
                return this.$store.getters.count;
            },

            total() {
                return this.$store.getters.total;
            },

            products() {
                return this.$store.getters.cart;
            },

            expand() {
                return this.$store.state.show;
            }
        },

        methods: {
            increase(product, updateFrom) {
                this.$store.dispatch(Actions.addProductToCart, {
                    ticket: this.ticket,
                    action: 'increase',
                    product,
                    updateFrom
                });
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: [this.serializeProduct(product)]
                    }
                });
            },

            decrease(product, updateFrom) {
                if (product.quantity < minRequired) return;

                this.$store.dispatch(Actions.addProductToCart, {
                    ticket: this.ticket,
                    action: 'decrease',
                    product,
                    updateFrom
                });
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                        items: [this.serializeProduct(product, {quantity: 1})]
                    }
                });
            },

            remove(product) {
                this.$store.dispatch(Actions.removeProductFromCart, {
                    ticket: this.ticket,
                    product
                });

                dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                        items: [this.serializeProduct(product, {quantity: 0})]
                    }
                });
            },

            serializeProduct(product, overrides) {
                return {
                    item_name: product.ticket_name + " " + product.person,
                    item_id: product.product_id,
                    price: parseInt(product.unit_price),
                    item_brand: "Valle Plus",
                    item_category: product.ticket_name,
                    item_category2: product.person,
                    quantity: product.quantity,
                    currency: 'CLP',
                    ...overrides
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/mixins/cartMixin.vue